export default __webpack_public_path__ + "e18a9633788ec39a1a4cc3315b235006.png";